import React from 'react';
import { StopCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import Timer from './Timer';
import ScoringPanel from './ScoringPanel';
import Scoreboard from './Scoreboard';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from '../ui/alert-dialog';

const ActiveGame = ({ gameId, gameState, onEndGame, onRefresh }) => {
  const currentTeam = gameState.teams[gameState.current_team_index];

  return (
    <div className="space-y-6">
      {/* Game Info Header */}
      <Card className="bg-gradient-to-r from-[hsl(var(--accent))] to-[hsl(var(--secondary))] text-white border-0">
        <div className="p-6">
          <div className="flex items-center justify-between flex-wrap gap-4">
            <div>
              <div className="flex items-center gap-2 mb-1">
                <Badge className="bg-white/20 text-white border-0" data-testid="current-round-badge">
                  Round {gameState.current_round}
                </Badge>
                <Badge className="bg-white/20 text-white border-0" data-testid="current-song-badge">
                  Song {gameState.current_song}/10
                </Badge>
              </div>
              <h2 className="text-2xl md:text-3xl font-[var(--font-display)] tracking-tight" data-testid="current-team-name">
                {currentTeam.name}'s Turn
              </h2>
            </div>
            <AlertDialog>
              <AlertDialogTrigger asChild>
                <Button variant="destructive" className="rounded-xl" data-testid="end-game-button">
                  <StopCircle className="mr-2 h-4 w-4" />
                  End Game
                </Button>
              </AlertDialogTrigger>
              <AlertDialogContent>
                <AlertDialogHeader>
                  <AlertDialogTitle>End this game?</AlertDialogTitle>
                  <AlertDialogDescription>
                    This will end the current game and reset everything. You can view the final scores before ending.
                  </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                  <AlertDialogCancel>Cancel</AlertDialogCancel>
                  <AlertDialogAction onClick={onEndGame} data-testid="confirm-end-game">
                    End Game
                  </AlertDialogAction>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialog>
          </div>
        </div>
      </Card>

      {/* Main Game Grid */}
      <div className="grid lg:grid-cols-2 gap-6">
        {/* Left Column - Timer & Scoring */}
        <div className="space-y-6">
          <Timer gameId={gameId} onRefresh={onRefresh} />
          <ScoringPanel 
            gameId={gameId}
            gameState={gameState}
            onRefresh={onRefresh}
          />
        </div>

        {/* Right Column - Scoreboard */}
        <div>
          <Scoreboard gameState={gameState} />
        </div>
      </div>
    </div>
  );
};

export default ActiveGame;
